export default "__VITE_ASSET__C4QE$xWq__"